const groupHistoryMetaItems = (items, filter = '') => {
	const today = new Date();
	today.setHours(0, 0, 0, 0); // Normalize today's date

	const groups = new Map();
	const addToGroup = (key, item) => {
		if (!groups.has(key)) {
			groups.set(key, []);
		}
		groups.get(key).push(item);
	};

	if (filter) {
		items = filterHistoryMetaItems(items, filter);
	}

	items.forEach((item) => {
		const itemDate = new Date(item.createdAt);
		itemDate.setHours(0, 0, 0, 0); // Normalize item date

		const diffDays = Math.floor((today - itemDate) / (1000 * 60 * 60 * 24));
		if (diffDays < 0) return;

		if (diffDays === 0) {
			addToGroup('today', item);
		} else if (diffDays === 1) {
			addToGroup('yesterday', item);
		} else if (diffDays <= 7) {
			addToGroup('last_7_days', item);
		} else if (diffDays <= 30) {
			addToGroup('last_30_days', item);
		} else {
			// Group by month or year
			const currentYear = today.getFullYear();
			const itemYear = itemDate.getFullYear();

			if (itemYear === currentYear) {
				const month = itemDate.toLocaleString('en', { month: 'long' });
				addToGroup(month, item);
			} else {
				addToGroup(String(itemYear), item);
			}
		}
	});

	// Sort each group by timestamp descending
	for (const items of groups.values()) {
		items.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
	}

	// Sort the groups by predefined order and month names
	const fixedOrder = ['today', 'yesterday', 'last_7_days', 'last_30_days'];
	const monthOrder = [
		'January',
		'February',
		'March',
		'April',
		'May',
		'June',
		'July',
		'August',
		'September',
		'October',
		'November',
		'December',
	];

	return Array.from(groups.entries()).sort(([a], [b]) => {
		const groupSortWeight = (key) => {
			// Check if the key is in the fixed order
			const fixedIndex = fixedOrder.indexOf(key);
			if (fixedIndex !== -1) return 0 + fixedIndex;

			// Check if the key is a month and sort it in descending order
			const monthIndex = monthOrder.indexOf(key);
			if (monthIndex !== -1) return 10 + (11 - monthIndex);

			// Check if the key is a year and sort it in descending order
			const isYear = /^\d{4}$/.test(key);
			if (isYear) return 100 + (9999 - parseInt(key));

			// Fallback for any other keys
			return 99999;
		};
		return groupSortWeight(a) - groupSortWeight(b);
	});
};

const filterHistoryMetaItems = (items, filterString) => {
	return items.filter((item) => {
		const filterStringList = filterString.toLowerCase().split(' ');

		if (item.label) {
			return filterStringList.every((filterString) => item.label?.toLowerCase().includes(filterString));
		}

		if (item.question) {
			return filterStringList.every((filterString) => item.question?.toLowerCase().includes(filterString));
		}

		return false;
	});
};

export { groupHistoryMetaItems, filterHistoryMetaItems };
